export default __webpack_public_path__ + "media/images/icon_about-46ecab9d267deff245eefec24765b056.png";